<template>
  <div class="news-detail-page">
    <PageHeader title="企业动态" :subtitle="news?.title || '新闻详情'" :currentText="news?.title || '加载中...'" />

    <div class="page-container" v-loading="loading">
      <!-- 新闻详情 -->
      <div v-if="news" class="news-detail">
        <div class="news-header">
          <h1 class="news-title">{{ news.title }}</h1>
          <div class="news-meta">
            <div class="category">{{ getCategoryName(news.category) }}</div>
            <span class="date">{{ formatDate(news.editTime) }}</span>
            <span class="views">阅读：{{ news.viewCount || 0 }}</span>
          </div>
        </div>

        <div class="news-cover" v-if="news.cover">
          <img :src="news.cover" :alt="news.title">
        </div>

        <div class="news-content" v-html="news.content"></div>
      </div>

      <!-- 错误提示 -->
      <el-alert v-if="error" type="error" :title="error" :closable="false" show-icon></el-alert>

      <!-- 相关新闻 -->
      <div class="related-news" v-if="relatedNews.length > 0">
        <h2 class="section-title">相关新闻</h2>
        <div class="related-list">
          <div v-for="item in relatedNews" :key="item._id" class="related-item">
            <ArticleCard :id="item._id" :title="item.title" :summary="getSummary(item.content, 80)" :cover="item.cover"
              :date="item.editTime" :category="getCategoryName(item.category)" type="news" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getNewsDetail, getHotNews, getNewsCategories } from '@/api/news';
import { useApi } from '@/utils/useApi';
import { formatDate, getSummary } from '@/utils/helper';
import PageHeader from '@/components/PageHeader.vue';
import ArticleCard from '@/components/ArticleCard.vue';

export default {
  name: 'NewsDetailView',
  components: {
    PageHeader,
    ArticleCard
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const newsId = ref(route.params.id);
    const categories = ref([]);
    const relatedNews = ref([]);
    const error = ref('');
    const loading = ref(false);
    const news = ref({
      // _id: 'news1',
      // title: '爆火收官！沃雷顿2025上海展圆满成功，以卓越之姿引领未来！',
      // category: 1,
      // viewCount: 100,
      // content: '<p style=\"text-align: justify;\"><img src=\"https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/5d16f1b6f58b4340806c33a0858d0dd7_mergeImage.png\" alt=\"\" data-href=\"\" style=\"\"></p><p style=\"text-align: justify;\">5月25日，沃雷顿为中国国家山地自行车队打造的巴黎奥运会战车交车仪式，在“沃雷顿杯”巴黎奥运会备战赛暨2024年中国山地自行车联赛（深圳·光明站）的赛前举行。</p><p style=\"text-align: justify;\"><br></p><p style=\"text-align: justify;\"><img src=\"https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/5d16f1b6f58b4340806c33a0858d0dd7_mergeImage.png\" alt=\"\" data-href=\"\" style=\"\"></p><p style=\"text-align: justify;\">国家体育总局反兴奋剂中心副主任 王新宅，中国自行车运动协会副秘书长 彭海波，广东省社会体育和训练竞赛中心主任 蔡建祥，深圳市光明区委常委、宣传部部长 吴志伟，光明区文化广电旅游体育局局长 包小红，光明区新湖街道党工委书记 刘林海，深圳市沃雷顿自行车股份有限公司董事长 谭伟龙，中国国家山地自行车队教练及运动员，参赛选手，媒体及观众等人员共同见证这一重要时刻。沃雷顿连续两届奥运会为国家队提供竞赛器材、保驾护航，展现了自主研发、自主制造的卓越能力。</p><p style=\"text-align: justify;\"><br></p><p style=\"text-align: justify;\"><img src=\"https://xideshengcn.oss-cn-shenzhen.aliyuncs.com/2025/02/19/1739931044651-MtC.png\" alt=\"\" data-href=\"\" style=\"\"></p><p style=\"text-align: justify;\">在交付仪式上，沃雷顿集团董事长谭伟龙表示：“我们非常荣幸能够为国家队提供巴黎奥运会比赛用车，这是我们作为中国自行车行业领军企业的一份责任，更是一种自豪。我们将以自主尖端科技创造好产品，一路向前，矢志领先，为中国自行车运动事业的发展贡献更多的力量。”</p><p style=\"text-align: justify;\"><br></p><p style=\"text-align: justify;\"><img src=\"https://xideshengcn.oss-cn-shenzhen.aliyuncs.com/2025/02/19/1739931050409-QpL.png\" alt=\"\" data-href=\"\" style=\"\"></p><p style=\"text-align: justify;\">中国自行车运动协会副秘书长彭海波也对沃雷顿公司的支持表示了衷心的感谢，并表示：“沃雷顿公司为我们提供的比赛用车，是我们在巴黎奥运会上取得优异成绩的有力保障。我们将以更加饱满的热情和更加坚定的信心，迎接即将到来的挑战。”</p><p style=\"text-align: justify;\"><br></p><p style=\"text-align: justify;\"><img src=\"https://xideshengcn.oss-cn-shenzhen.aliyuncs.com/2025/02/19/1739931057743-TnC.png\" alt=\"\" data-href=\"\" style=\"\"></p><p style=\"text-align: justify;\">此次交付的巴黎奥运会比赛用车，采用T1100碳纤维材料打造，车架仅有1150克的“梦幻”重量，整车仅重9.6千克，采用单转点一体式后三角结构等多项精妙设计，在全球同级产品中做到了最轻，是尖端科技与前沿潮流的完美呈现，整车具备了重量轻、强度高、舒适度高、操控性好、通过性好、结构优化、外型流畅等优点。奥运战车的涂装以中国红和中华巨龙彰显民族自豪，具有高科技、高品质、高颜值的特点。</p><p style=\"text-align: justify;\"><br></p><p style=\"text-align: justify;\">作为中国自行车运动协会的长期合作伙伴，沃雷顿公司有着雄厚的实力，沃雷顿在全球员工数已超1万名，建设了5大生产基地，其中包括中国最大的镁合金新材料研发生产基地和全球最大的碳纤维研发制造基地。沃雷顿公司一直积极投身于中国自行车运动的发展，为国家队提供高品质的自行车器材，国家队使用沃雷顿亚运战车先后获得两次亚锦赛冠军，并且斩获亚运会男女双料冠亚军。</p><p style=\"text-align: justify;\"><br></p><p style=\"text-align: justify;\">民族品牌，助力奥运！征程已启，剑指巴黎！期待奥运健儿们在巴黎奥运会取得优异的成绩，为国争光！</p>',
      // cover: '',
      // editTime: new Date().toISOString()
    })


    // 获取新闻分类
    const fetchCategories = async () => {
      try {
        const res = await getNewsCategories();
        if (res.data && res.data.code === 200) {
          categories.value = res.data?.rows.map(item => {
            return {
              id: item.dictValue,
              name: item.dictLabel,
            }
          })
        }
      } catch (error) {
        console.error('获取新闻分类失败:', error);
      }
    };

    // 获取相关新闻
    const fetchNewsDetail = async (newId) => {
      try {
        const res = await getNewsDetail(newId);
        if (res.data && res.data.code === 200) {
          news.value = {
              _id: res.data?.data.noticeId,
              title: res.data?.data.noticeTitle,
              content: res.data?.data.noticeContent,
              viewCount: res.data?.data.viewCount || 0,
              cover: res.data?.data.pic || '',
              category: res.data?.data.noticeType,
              editTime: res.data?.data.publishTime || new Date().toISOString()
          }
        }
      } catch (error) {
        console.error('获取相关新闻详情失败:', error);
      }
    };

    // 获取相关新闻
    const fetchRelatedNews = async () => {
      try {
        const res = await getHotNews({ pageNum:0, pageSize: 3 });
        if (res.data && res.data.code === 200) {
          relatedNews.value = res.data?.rows.map(item => {
            return {
              _id: item.noticeId,
              title: item.noticeTitle,
              content: item.subtitle,
              cover: item.pic || '',
              category: item.noticeType,
              editTime: item.publishTime || new Date().toISOString()
            }
          })
        }
      } catch (error) {
        console.error('获取相关新闻失败:', error);
      }
    };

    // 获取分类名称
    const getCategoryName = (categoryId) => {
      if (!categoryId) return '未分类';
      const category = categories.value.find(c => c.id === categoryId);
      return category ? category.name : '未分类';
    };

    // 加载数据
    const loadData = () => {
      fetchNewsDetail(newsId.value);
      fetchRelatedNews();
    };

    // 监听路由ID变化
    watch(() => route.params.id, (newId) => {
      if (newId && newId !== newsId.value) {
        newsId.value = newId;
        loadData();
      }
    });

    onMounted(() => {
      fetchCategories();
      loadData();
    });

    return {
      news,
      error,
      loading,
      relatedNews,
      formatDate,
      getSummary,
      getCategoryName
    };
  }
}
</script>

<style lang="scss" scoped>
.news-detail-page {
  background-color: #e5e7eb;

  .news-detail {
    background-color: #FFF;
    padding: 20px;

    .news-header {
      margin-bottom: 30px;
      text-align: center;
      padding-bottom: 6px;
      border-bottom: 1px solid #e5e7eb;

      .news-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 15px;
      }

      .news-meta {
        display: flex;
        justify-content: center;
        color: #999;
        font-size: 14px;
        gap: 20px;

        .category {
          background-color: #f0f9ff;
          color: #409eff;
          padding: 0px 8px;
          border-radius: 2px;
        }
      }
    }

    .news-cover {
      margin-bottom: 30px;
      text-align: center;

      img {
        max-width: 100%;
        border-radius: 8px;
      }
    }

    .news-content {
      font-size: 16px;
      line-height: 1.8;
      color: #333;

      ::v-deep(img) {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 1rem auto;
      }

      ::v-deep(p) {
        //margin-bottom: 1em;
        margin-bottom: 0px;
      }

      ::v-deep(h2) {
        margin: 1.5em 0 0.8em;
        font-size: 22px;
      }

      ::v-deep(h3) {
        margin: 1.2em 0 0.6em;
        font-size: 20px;
      }
    }
  }

  .related-news {
    padding-top: 50px;
    padding-bottom: 50px;

    .section-title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
      position: relative;
      padding-left: 15px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        height: 20px;
        width: 4px;
        background-color: #409eff;
      }
    }

    .related-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;

      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>